<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">合作伙伴信息设置</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>

        <van-cell>
            提示：此功能用于设置或修改合作伙伴信息，成为合作伙伴必须先关注公众号，然后提供ID号（通过"个人中心"查看）
        </van-cell>

        <van-form label-width="120" @submit="addManger">
            <van-field v-model="organ.user_id" type="number" name="user_id" label="合作伙伴id:" placeholder="合作伙伴id"
                       :rules="[{ required: true, message: '合作伙伴id' }]"/>
            <van-field v-model="organ.pid" type="number" name="pid" label="上级机构id:" placeholder="上级机构id"/>
            <van-field v-model="organ.name" name="organ_name" label="机构名称:" placeholder="机构名称"
                       :rules="[{ required: true, message: '机构名称' }]"/>
            <van-field v-model="organ.contact_name" name="contact_name" label="联系人:" placeholder="联系人"/>
            <van-field v-model="organ.contact_phone" name="contact_phone" label="联系号码:" placeholder="联系号码"/>
            <van-field v-model="organ.we_chat_number" name="we_chat_number" label="提成微信号:" placeholder="提成微信号"/>
            <van-field v-model="organ.commission_percentage" type="number" name="commission_percentage" label="提成比例:"
                       placeholder="提成比例"/>
            <van-field v-model="organ.pid_commission_percentage" type="number" name="pid_commission_percentage"
                       label="上级提成比例:" placeholder="上级提成比例"/>
            <van-field v-model="organ.discount_percentage" type="number" name="discount_percentage" label="学员充值折扣:"
                       placeholder="学员充值折扣"/>

            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
        </van-form>


        <van-dialog v-model="loading" title="" :show-confirm-button="false">
            <br>
            <van-loading size="50px" vertical>{{loading_text}}</van-loading>
            <br>
        </van-dialog>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                organ: {},

                order_no: "",
                pay_no: "",

                loading: false,
                loading_text: "加载中",
                error: false,
                error_text: "",
            };
        },
        created() {

        },
        methods: {
            addManger() {
                var saveOrgan = {
                    user_id: 0,
                    pid: 0,
                    name: "",
                    we_chat_number: "",
                    contact_name: "",
                    contact_phone: "",
                    commission_percentage: 0,
                    pid_commission_percentage: 0,
                    discount_percentage: 0,
                }
                if (this.organ.pid) {
                    saveOrgan.pid = parseInt(this.organ.pid);
                }

                if (this.organ.user_id) {
                    saveOrgan.user_id = parseInt(this.organ.user_id);
                }
                saveOrgan.name = this.organ.name;
                saveOrgan.we_chat_number = this.organ.we_chat_number;
                saveOrgan.contact_name = this.organ.contact_name;
                saveOrgan.contact_phone = this.organ.contact_phone;

                if (this.organ.commission_percentage) {
                    saveOrgan.commission_percentage = parseFloat(this.organ.commission_percentage);
                }
                if (this.organ.pid_commission_percentage) {
                    saveOrgan.pid_commission_percentage = parseFloat(this.organ.pid_commission_percentage);
                }
                if (this.organ.discount_percentage) {
                    saveOrgan.discount_percentage = parseFloat(this.organ.discount_percentage);
                }
                console.log(this.organ)
                console.log(saveOrgan)
                this.$http.post("/wechat/organ", saveOrgan).then(res => {
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.$toast.fail(res.data.msg);
                        return
                    }
                    this.$toast.success("提交成功")
                    this.$router.push('/my');
                });
            },
        }
    }
</script>
